<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->

<template>
    <div>
        <div v-if="mobileView">
            <div class="flex space-x-2 items-end">
                <div
                    class="group/contenteditable-container bg-cs-main-50 rounded-md p-2 border border-cs-main-500 flex-1 flex justify-between items-center">
                    <div class="flex items-center space-x-2 flex-1 min-w-0">
                        <span class="w-3 h-3 flex-shrink-0 rounded-full" :class="colors[selectedSubmitter.uuid]" />
                        <Contenteditable v-model="selectedSubmitter.name" class="cursor-text" :icon-inline="true"
                            :editable="editable" :select-on-edit-click="true" :icon-width="18"
                            @update:model-value="$emit('name-change', selectedSubmitter)" />
                    </div>
                    <div v-if="editable" class="flex items-center flex-shrink-0">
                        <span
                            class="cursor-pointer flex items-center justify-center transition-all duration-75 hover:bg-cs-main-100 w-6 h-6 rounded"
                            title="Pilih Kontak" @click.stop="handleAddressBookClick">
                            <IconAddressBook width="18" height="18" />
                        </span>
                    </div>
                </div>

                <!-- Mobile Dropdown Trigger -->
                <div v-if="editable" class="dropdown dropdown-top dropdown-end flex-shrink-0 z-10">
                    <label tabindex="0"
                        class="bg-cs-main-50 cursor-pointer rounded-md p-2 border border-cs-main-500 flex justify-center items-center min-w-[44px]"
                        @click="toggleDropdown">
                        <IconUsersPlus width="24" height="24" />
                    </label>
                    <ul v-if="renderDropdown" tabindex="0"
                        class="dropdown-content max-h-[60svh] menu px-1 shadow-xl rounded-box bg-white mb-2 min-w-max border border-base-300 !z-[9999] overflow-y-auto"
                        :style="mobileDropdownStyle">
                        <li v-for="submitter in submitters" :key="submitter.uuid">
                            <a href="#" class="flex px-2 group justify-between items-center"
                                :class="{ 'bg-cs-main-100 hover:bg-cs-main-200': submitter.uuid === modelValue }"
                                @click.prevent="selectSubmitter(submitter); move(submitter, 0)">
                                <span class="flex items-center">
                                    <span class="rounded-full w-3 h-3 ml-1 mr-3" :class="colors[submitter.uuid]" />
                                    <span>
                                        {{ submitter.name }}
                                    </span>
                                </span>
                                <div v-if="submitters.length > 1" class="flex items-center">
                                    <button class="px-2" @click.prevent.stop="remove(submitter)">
                                        <IconTrashX :width="18" />
                                    </button>
                                </div>
                            </a>
                        </li>
                        <li v-if="submitters.length < names.length && allowAddNew">
                            <a href="#" class="flex px-2" @click.prevent="addSubmitter">
                                <IconUserPlus :width="20" :stroke-width="1.6" />
                                <span class="py-1">
                                    {{ t('add') }} {{ names[submitters.length] }}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-else class="w-full">
            <!-- Selected Submitter Header -->
            <div v-if="compact" class="cursor-pointer text-base-100 flex h-full items-center justify-center">
                <button class="mx-1 w-3 h-3 rounded-full" :class="colors[selectedSubmitter.uuid]" />
            </div>
            <div v-else id="selected-submited"
                class="group group/contenteditable-container rounded-md p-2 border border-base-300 bg-white w-full flex justify-between items-center mb-2">
                <div class="flex items-center space-x-2">
                    <span class="w-3 h-3 rounded-full" :class="colors[selectedSubmitter.uuid]" />
                    <Contenteditable v-model="selectedSubmitter.name" class="cursor-text" :icon-inline="true"
                        :editable="editable" :select-on-edit-click="true" :icon-width="18"
                        @update:model-value="$emit('name-change', selectedSubmitter)" />
                </div>
                <div class="flex items-center">
                    <template v-if="editable">
                        <span
                            class="cursor-pointer flex items-center justify-center transition-all duration-75 hover:bg-cs-main-100 w-6 h-6 rounded mr-1"
                            title="Pilih Kontak" @click.stop="handleAddressBookClick">
                            <IconAddressBook width="18" height="18" />
                        </span>
                    </template>
                </div>
            </div>

            <!-- List  -->
            <div v-if="(editable || !compact)" class="w-full">
                <ul class="menu bg-white rounded-lg border border-base-300 p-2">
                    <li v-for="submitter in submitters" :key="submitter.uuid" @click.prevent.stop="move(submitter, 0)">
                        <a href="#" class="flex px-2 group justify-between items-center rounded-md"
                            :class="{ 'bg-cs-main-100 hover:bg-cs-main-200': submitter.uuid === modelValue, 'py-0.5': submitters.length > 8 }"
                            @click.prevent="selectSubmitter(submitter)">
                            <span class="py-1 flex items-center">
                                <span class="rounded-full w-3 h-3 ml-1 mr-3" :class="colors[submitter.uuid]" />
                                <span>
                                    {{ submitter.name }}
                                </span>
                            </span>
                            <div v-if="!compact && submitters.length > 1 && editable" class="flex">
                                <div class="flex-col pr-1 hidden group-hover:flex -mt-1 h-0">
                                    <button :title="t('up')" class="relative w-2"
                                        style="font-size: 10px; margin-bottom: -4px"
                                        @click.prevent.stop="move(submitter, -1)">
                                        ▲
                                    </button>
                                    <button :title="t('down')" class="relative w-2"
                                        style="font-size: 10px; margin-top: -4px"
                                        @click.prevent.stop="move(submitter, 1)">
                                        ▼
                                    </button>
                                </div>
                                <button v-if="!compact && submitters.length > 1 && editable"
                                    class="hidden group-hover:block px-2" @click.prevent.stop="remove(submitter)">
                                    <IconTrashX :width="18" />
                                </button>
                            </div>
                        </a>
                    </li>
                    <li v-if="submitters.length < names.length && editable && allowAddNew">
                        <a href="#" class="flex px-2 rounded-md" @click.prevent="addSubmitter">
                            <IconUserPlus :width="20" :stroke-width="1.6" />
                            <span class="py-1">
                                {{ t('add') }} {{ names[submitters.length] }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Contact Modal - Shared between mobile and desktop -->
        <ContactModal v-model="isModalOpen" @select-contact="handleContactSelect" />
    </div>
</template>

<script>
import { IconUserPlus, IconTrashX, IconAddressBook, IconUsersPlus } from '@tabler/icons-vue'
import Contenteditable from './contenteditable'
import ContactModal from './contact_modal.vue'
import { v4 } from 'uuid'

export default {
    name: 'FieldSubmitter',
    components: {
        IconUserPlus,
        Contenteditable,
        IconTrashX,
        IconUsersPlus,
        IconAddressBook,
        ContactModal
    },
    inject: ['t', 'save'],
    props: {
        submitters: {
            type: Array,
            required: true
        },
        editable: {
            type: Boolean,
            required: false,
            default: true
        },
        compact: {
            type: Boolean,
            required: false,
            default: false
        },
        mobileView: {
            type: Boolean,
            required: false,
            default: false
        },
        allowAddNew: {
            type: Boolean,
            required: false,
            default: true
        },
        modelValue: {
            type: String,
            required: true
        },
        menuStyle: {
            type: Object,
            required: false,
            default: () => ({})
        },
        menuClasses: {
            type: String,
            required: false,
            default: 'dropdown-content menu p-2 shadow rounded-box w-full z-10'
        }
    },
    emits: ['update:model-value', 'remove', 'new-submitter', 'name-change'],
    data() {
        return {
            renderDropdown: false,
            isModalOpen: false
        }
    },
    computed: {
        colorClasses() {
            return [
                'bg-red-500',
                'bg-sky-500',
                'bg-emerald-500',
                'bg-yellow-300',
                'bg-purple-600',
                'bg-pink-500',
                'bg-cyan-500',
                'bg-orange-500',
                'bg-lime-500',
                'bg-indigo-500',
                'bg-red-500',
                'bg-sky-500',
                'bg-emerald-500',
                'bg-yellow-300',
                'bg-purple-600',
                'bg-pink-500',
                'bg-cyan-500',
                'bg-orange-500',
                'bg-lime-500',
                'bg-indigo-500',
                'bg-red-500',
                'bg-sky-500',
                'bg-emerald-500',
                'bg-yellow-300',
                'bg-purple-600',
                'bg-pink-500',
                'bg-cyan-500',
                'bg-orange-500',
                'bg-lime-500',
                'bg-indigo-500',
                'bg-red-500',
                'bg-sky-500',
                'bg-emerald-500',
                'bg-yellow-300',
                'bg-purple-600',
                'bg-pink-500',
                'bg-cyan-500',
                'bg-orange-500',
                'bg-lime-500',
                'bg-indigo-500',
                'bg-red-500',
                'bg-sky-500',
                'bg-emerald-500',
                'bg-yellow-300',
                'bg-purple-600',
                'bg-pink-500',
                'bg-cyan-500',
                'bg-orange-500',
                'bg-lime-500',
                'bg-indigo-500'
            ]
        },
        colors() {
            // Create a stable mapping of submitter UUIDs to colors
            // Use the submitter's index in the array (creation order)
            const colorMap = {}

            this.submitters.forEach((submitter, index) => {
                colorMap[submitter.uuid] = this.colorClasses[index % this.colorClasses.length]
            })

            return colorMap
        },
        names() {
            return [
                this.t('first_party'),
                this.t('second_party'),
                this.t('third_party'),
                this.t('fourth_party'),
                this.t('fifth_party'),
                this.t('sixth_party'),
                this.t('seventh_party'),
                this.t('eighth_party'),
                this.t('ninth_party'),
                this.t('tenth_party'),
                this.t('eleventh_party'),
                this.t('twelfth_party'),
                this.t('thirteenth_party'),
                this.t('fourteenth_party'),
                this.t('fifteenth_party'),
                this.t('sixteenth_party'),
                this.t('seventeenth_party'),
                this.t('eighteenth_party'),
                this.t('nineteenth_party'),
                this.t('twentieth_party'),
                this.t('twenty_first_party'),
                this.t('twenty_second_party'),
                this.t('twenty_third_party'),
                this.t('twenty_fourth_party'),
                this.t('twenty_fifth_party'),
                this.t('twenty_sixth_party'),
                this.t('twenty_seventh_party'),
                this.t('twenty_eighth_party'),
                this.t('twenty_ninth_party'),
                this.t('thirtieth_party'),
                this.t('thirty_first_party'),
                this.t('thirty_second_party'),
                this.t('thirty_third_party'),
                this.t('thirty_fourth_party'),
                this.t('thirty_fifth_party'),
                this.t('thirty_sixth_party'),
                this.t('thirty_seventh_party'),
                this.t('thirty_eighth_party'),
                this.t('thirty_ninth_party'),
                this.t('fortieth_party'),
                this.t('forty_first_party'),
                this.t('forty_second_party'),
                this.t('forty_third_party'),
                this.t('forty_fourth_party'),
                this.t('forty_fifth_party'),
                this.t('forty_sixth_party'),
                this.t('forty_seventh_party'),
                this.t('forty_eighth_party'),
                this.t('forty_ninth_party'),
                this.t('fiftieth_party')
            ]
        },
        selectedSubmitter() {
            return this.submitters.find((e) => e.uuid === this.modelValue)
        },
        mobileDropdownStyle() {
            return {
                ...this.menuStyle,
                maxHeight: '60svh',
                zIndex: '99999'
            }
        }
    },
    methods: {
        toggleDropdown() {
            this.renderDropdown = !this.renderDropdown
        },
        selectSubmitter(submitter) {
            this.$emit('update:model-value', submitter.uuid)
            // Close dropdown after selection in mobile view
            if (this.mobileView) {
                this.renderDropdown = false
            }
        },
        remove(submitter) {
            if (window.confirm(this.t('are_you_sure'))) {
                this.$emit('remove', submitter)
            }
        },
        move(submitter, direction) {
            const currentIndex = this.submitters.indexOf(submitter)

            this.submitters.splice(currentIndex, 1)

            if (currentIndex + direction > this.submitters.length) {
                this.submitters.unshift(submitter)
            } else if (currentIndex + direction < 0) {
                this.submitters.push(submitter)
            } else {
                this.submitters.splice(currentIndex + direction, 0, submitter)
            }

            this.selectSubmitter(submitter)

            this.save()
        },
        addSubmitter() {
            const newSubmitter = {
                name: this.names[this.submitters.length],
                email: '', // Initialize with empty email
                uuid: v4()
            }

            this.submitters.push(newSubmitter)

            this.$emit('update:model-value', newSubmitter.uuid)
            this.$emit('new-submitter', newSubmitter)

            // Close dropdown after adding new submitter in mobile view
            if (this.mobileView) {
                this.renderDropdown = false
            }
        },
        closeDropdown() {
            document.activeElement.blur()
            this.renderDropdown = false
        },
        handleAddressBookClick() {
            this.isModalOpen = true
        },
        handleContactSelect(contact) {
            // Update the current submitter's name and email with the selected contact's information
            if (this.selectedSubmitter) {
                this.selectedSubmitter.name = contact.name
                this.selectedSubmitter.email = contact.email

                // Emit the name change event to notify parent components
                this.$emit('name-change', this.selectedSubmitter)
            }
        }
    }
}
</script>
